// Frontend/src/pages/fit/ManageAccounts.js - Version complète corrigée

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { auth } from "../../firebaseConfig"; // 🔥 AJOUTÉ : Import de auth

const ManageAccounts = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("comptes"); // 'comptes' ou 'clients'
  const [loading, setLoading] = useState(true);

  // États pour les comptes utilisateurs
  const [accounts, setAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("tous");

  // États pour les clients finaux
  const [clientsFinaux, setClientsFinaux] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  // 🔥 NOUVEAU : Fonction pour obtenir les headers avec authentification
  const getAuthHeaders = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        throw new Error("Utilisateur non connecté");
      }

      const token = await currentUser.getIdToken(true); // force refresh
      console.log("🔑 Token généré:", token ? "OUI" : "NON"); // DEBUG

      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
    } catch (error) {
      console.error("❌ Erreur getAuthHeaders:", error);
      throw error;
    }
  };

  // Charger les comptes utilisateurs
  const fetchAccounts = async () => {
    try {
      const headers = await getAuthHeaders(); // 🔥 AJOUTÉ : Authentification
      const response = await fetch(
        `${API_BASE_URL}/api/users/get-all-accounts`,
        {
          headers,
        }
      );
      const data = await response.json();

      if (data.success) {
        setAccounts(data.accounts);
        setFilteredAccounts(data.accounts);
      } else {
        toast.error("Erreur lors du chargement des comptes");
      }
    } catch (error) {
      console.error("Erreur:", error);
      toast.error("Erreur de connexion");
    }
  };

  // 🔥 CORRIGÉ : Charger les clients finaux avec authentification
  const fetchClientsFinaux = async () => {
    try {
      console.log("🔄 Chargement des clients finaux...");

      const headers = await getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/api/clients/finaux`, {
        headers,
      });

      console.log("📊 Response status:", response.status);
      const data = await response.json();
      console.log("📊 Data reçue:", data); // 🔥 LOG AJOUTÉ

      if (data.success) {
        console.log("📊 Clients dans data.clients:", data.clients); // 🔥 LOG AJOUTÉ
        console.log("📊 Nombre de clients:", data.clients.length); // 🔥 LOG AJOUTÉ
        setClientsFinaux(data.clients);
        console.log(
          "📊 State mis à jour avec:",
          data.clients.length,
          "clients"
        ); // 🔥 LOG AJOUTÉ
      } else {
        console.log("❌ Success = false:", data); // 🔥 LOG AJOUTÉ
      }
    } catch (error) {
      console.error("❌ Erreur clients finaux:", error);
      setClientsFinaux([]);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      if (activeTab === "comptes") {
        await fetchAccounts();
      } else {
        await fetchClientsFinaux();
      }
      setLoading(false);
    };

    loadData();
  }, [activeTab]);

  // ✅ CORRIGÉ : Filtrage des comptes avec protection toLowerCase
  useEffect(() => {
    let filtered = accounts;

    if (searchTerm) {
      filtered = filtered.filter(
        (account) =>
          (account.email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
          (account.nom || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
          (account.prenom || '').toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedRole !== "tous") {
      filtered = filtered.filter((account) => account.role === selectedRole);
    }

    setFilteredAccounts(filtered);
  }, [accounts, searchTerm, selectedRole]);

  // ✅ CORRIGÉ : Filtrage des clients finaux avec protection toLowerCase
  useEffect(() => {
    let filtered = clientsFinaux;

    if (clientSearchTerm) {
      filtered = filtered.filter(
        (client) =>
          (client.email || '').toLowerCase().includes(clientSearchTerm.toLowerCase()) ||
          (client.nom || '').toLowerCase().includes(clientSearchTerm.toLowerCase()) ||
          (client.contact || '').toLowerCase().includes(clientSearchTerm.toLowerCase())
      );
    }

    setFilteredClients(filtered);
  }, [clientsFinaux, clientSearchTerm]);

  // 🔥 CORRIGÉ : Supprimer un compte avec authentification et debug
  const handleDeleteAccount = async (userId) => {
    console.log('🔍 userId reçu:', userId); // 🔥 AJOUTÉ pour debug
    console.log('🔍 Type:', typeof userId); // 🔥 AJOUTÉ pour debug
    
    if (!userId) {
      alert('Erreur : userId manquant !');
      return;
    }
    
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce compte ?")) {
      return;
    }
  
    try {
      console.log("🗑️ Suppression du compte:", userId);
  
      const headers = await getAuthHeaders();
      console.log('📋 Headers:', headers); // 🔥 AJOUTÉ pour debug
      
      // 🔥 CORRIGÉ : Envoyer 'uid' au lieu de 'userId' car l'API attend 'uid'
      const requestBody = { uid: userId };
      console.log('📦 Body à envoyer:', requestBody); // 🔥 AJOUTÉ pour debug
      
      const response = await fetch(`${API_BASE_URL}/api/users/delete-account`, {
        method: "DELETE",
        headers,
        body: JSON.stringify(requestBody),
      });
  
      console.log('📊 Response status:', response.status); // 🔥 AJOUTÉ pour debug
      
      if (!response.ok) {
        const errorText = await response.text();
        console.log('❌ Erreur response:', errorText);
        throw new Error(`Erreur ${response.status}: ${errorText}`);
      }
      
      const data = await response.json();
      console.log('✅ Réponse:', data); // 🔥 AJOUTÉ pour debug
  
      if (data.success) {
        toast.success("Compte supprimé avec succès");
        fetchAccounts();
      } else {
        toast.error(data.message || "Erreur lors de la suppression");
      }
    } catch (error) {
      console.error("❌ Erreur complète:", error);
      toast.error("Erreur de connexion: " + error.message);
    }
  };

  // Afficher les détails d'un client
  const handleViewClientDetails = (client) => {
    setSelectedClient(client);
  };

  // ✅ CORRIGÉ : Statistiques des rôles avec majuscules
  const getRoleStats = () => {
    const stats = accounts.reduce((acc, account) => {
      acc[account.role] = (acc[account.role] || 0) + 1;
      return acc;
    }, {});

    return [
      { role: "Tous", count: accounts.length, color: "bg-gray-500" },
      { role: "Revendeurs", count: stats.Revendeur || 0, color: "bg-blue-500" },
      {
        role: "Carrossiers",
        count: stats.Carrossier || 0,
        color: "bg-purple-500",
      },
      { role: "Admins FIT", count: stats.FIT || 0, color: "bg-red-500" },
      { role: "Clients", count: stats.Client || 0, color: "bg-green-500" },
    ];
  };

  // 🔥 NOUVEAU : Statistiques des clients finaux
  const getClientStats = () => {
    const totalDossiers = clientsFinaux.reduce(
      (sum, client) => sum + (client.totalDossiers || 0),
      0
    );
    const avgDossiers =
      clientsFinaux.length > 0
        ? Math.round((totalDossiers / clientsFinaux.length) * 10) / 10
        : 0;

    return {
      totalClients: clientsFinaux.length,
      totalDossiers,
      avgDossiers,
      withDossiers: clientsFinaux.filter((c) => (c.totalDossiers || 0) > 0)
        .length,
      withoutDossiers: clientsFinaux.filter((c) => (c.totalDossiers || 0) === 0)
        .length,
    };
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  const clientStats = getClientStats(); // 🔥 AJOUTÉ

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Header */}
      <div className="bg-white/80 backdrop-blur-xl border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                Gestion des{" "}
                {activeTab === "comptes" ? "comptes" : "clients finaux"}
              </h1>
              <p className="text-gray-600 mt-1">
                {activeTab === "comptes"
                  ? "Gérez tous les comptes utilisateurs du système"
                  : "Consultez tous les clients finaux ayant des dossiers CE"}
              </p>
            </div>

            {activeTab === "comptes" && (
              <button
                onClick={() => navigate("/fit/fit-create-account")}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center gap-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
                Créer un compte
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Onglets */}
        <div className="flex space-x-1 bg-gray-100 rounded-lg p-1 mb-8 w-fit">
          <button
            onClick={() => setActiveTab("comptes")}
            className={`px-6 py-3 rounded-md font-medium transition-colors ${
              activeTab === "comptes"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            <div className="flex items-center gap-2">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
              Comptes utilisateurs
            </div>
          </button>
          <button
            onClick={() => setActiveTab("clients")}
            className={`px-6 py-3 rounded-md font-medium transition-colors ${
              activeTab === "clients"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            <div className="flex items-center gap-2">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                />
              </svg>
              Clients finaux
            </div>
          </button>
        </div>

        {/* Contenu des onglets */}
        {activeTab === "comptes" ? (
          // Onglet Comptes utilisateurs
          <>
            {/* Statistiques */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
              {getRoleStats().map((stat, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-sm border border-gray-100 p-6"
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-3 h-3 rounded-full ${stat.color}`}></div>
                    <div>
                      <p className="text-2xl font-bold text-gray-900">
                        {stat.count}
                      </p>
                      <p className="text-sm text-gray-600">{stat.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Filtres */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Rechercher
                  </label>
                  <input
                    type="text"
                    placeholder="Email, nom, prénom..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="md:w-48">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Filtrer par rôle
                  </label>
                  <select
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="tous">Tous les rôles</option>
                    <option value="Revendeur">Revendeurs</option>
                    <option value="Carrossier">Carrossiers</option>
                    <option value="Client">Clients</option>
                    <option value="FIT">Admins FIT</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Tableau des comptes */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Utilisateur
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Rôle
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Statut
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Créé le
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredAccounts.map((account) => (
                      <tr key={account.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div>
                            <div className="text-sm font-medium text-gray-900">
                              {account.prenom || ''} {account.nom || ''}
                            </div>
                            <div className="text-sm text-gray-500">
                              {account.email || 'Email non renseigné'}
                            </div>
                            {account.company && (
                              <div className="text-xs text-gray-400">
                                {account.company}
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              account.role === "FIT"
                                ? "bg-red-100 text-red-800"
                                : account.role === "Revendeur"
                                ? "bg-blue-100 text-blue-800"
                                : account.role === "Carrossier"
                                ? "bg-purple-100 text-purple-800"
                                : "bg-green-100 text-green-800"
                            }`}
                          >
                            {account.role || 'Non défini'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              account.isApproved
                                ? "bg-green-100 text-green-800"
                                : "bg-yellow-100 text-yellow-800"
                            }`}
                          >
                            {account.isApproved ? "Approuvé" : "En attente"}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {account.createdAt ? 
                            new Date(account.createdAt).toLocaleDateString("fr-FR") :
                            'Date inconnue'
                          }
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          <button
                            onClick={() => handleDeleteAccount(account.id)}
                            className="text-red-600 hover:text-red-900 font-medium"
                          >
                            Supprimer
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {filteredAccounts.length === 0 && (
                <div className="text-center py-12">
                  <p className="text-gray-500">Aucun compte trouvé</p>
                </div>
              )}
            </div>
          </>
        ) : (
          // Onglet Clients finaux
          <>
            {/* 🔥 CORRIGÉ : Statistiques clients */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">
                      {clientStats.totalClients}
                    </p>
                    <p className="text-sm text-gray-600">Clients finaux</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-green-500"></div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">
                      {clientStats.totalDossiers}
                    </p>
                    <p className="text-sm text-gray-600">Dossiers CE total</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-purple-500"></div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">
                      {clientStats.avgDossiers}
                    </p>
                    <p className="text-sm text-gray-600">
                      Dossiers/client moyen
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-emerald-500"></div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">
                      {clientStats.withDossiers}
                    </p>
                    <p className="text-sm text-gray-600">Avec dossiers</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full bg-orange-500"></div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">
                      {clientStats.withoutDossiers}
                    </p>
                    <p className="text-sm text-gray-600">Sans dossiers</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Recherche clients */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Rechercher un client
                  </label>
                  <input
                    type="text"
                    placeholder="Email, nom d'entreprise, contact..."
                    value={clientSearchTerm}
                    onChange={(e) => setClientSearchTerm(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>

            {/* 🔥 CORRIGÉ : Tableau des clients finaux */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Entreprise
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Contact
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Email
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Téléphone
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Dossiers CE
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredClients.map((client) => (
                      <tr key={client.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900">
                            {client.nom || 'Nom non renseigné'}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {client.contact || 'Contact non renseigné'}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-500">
                            {client.email || 'Email non renseigné'}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-500">
                            {client.telephone || 'Non renseigné'}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            <span
                              className={`inline-flex px-3 py-1 text-sm font-semibold rounded-full ${
                                (client.totalDossiers || 0) > 0
                                  ? "bg-blue-100 text-blue-800"
                                  : "bg-gray-100 text-gray-600"
                              }`}
                            >
                              {client.totalDossiers || 0} dossier
                              {(client.totalDossiers || 0) > 1 ? "s" : ""}
                            </span>
                            <span
                              className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                                client.status === "Avec dossiers"
                                  ? "bg-green-100 text-green-700"
                                  : "bg-orange-100 text-orange-700"
                              }`}
                            >
                              {client.status}
                            </span>
                          </div>
                          {client.createdAt && (
                            <div className="text-xs text-gray-400 mt-1">
                              Créé:{" "}
                              {new Date(
                                client.createdAt.toDate
                                  ? client.createdAt.toDate()
                                  : client.createdAt
                              ).toLocaleDateString("fr-FR")}
                            </div>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          <button
                            onClick={() => handleViewClientDetails(client)}
                            className="text-blue-600 hover:text-blue-900 font-medium mr-4"
                          >
                            Voir détails
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {filteredClients.length === 0 && (
                <div className="text-center py-12">
                  <p className="text-gray-500">Aucun client final trouvé</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {/* Modal détails client */}
      {selectedClient && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Détails du client - {selectedClient.nom}
                  </h3>
                  <p className="text-gray-600">{selectedClient.contact}</p>
                </div>
                <button
                  onClick={() => setSelectedClient(null)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="p-6">
              {/* Informations client */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-gray-50 rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-3">
                    Informations de contact
                  </h4>
                  <div className="space-y-2">
                    <div>
                      <span className="text-sm text-gray-500">Email:</span>
                      <p className="font-medium">{selectedClient.email}</p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">Téléphone:</span>
                      <p className="font-medium">
                        {selectedClient.telephone || "Non renseigné"}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">Contact:</span>
                      <p className="font-medium">
                        {selectedClient.contact || "Non renseigné"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-3">
                    Statistiques
                  </h4>
                  <div className="space-y-2">
                    <div>
                      <span className="text-sm text-gray-500">
                        Nombre de dossiers:
                      </span>
                      <p className="font-medium">
                        {selectedClient.totalDossiers || 0}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">Statut:</span>
                      <p className="font-medium">{selectedClient.status}</p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">
                        Dossiers en profil:
                      </span>
                      <p className="font-medium">
                        {selectedClient.dossiersInProfile || 0}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">
                        Dossiers en collection:
                      </span>
                      <p className="font-medium">
                        {selectedClient.dossiersInCollection || 0}
                      </p>
                    </div>
                    {selectedClient.createdAt && (
                      <div>
                        <span className="text-sm text-gray-500">
                          Compte créé:
                        </span>
                        <p className="font-medium">
                          {new Date(
                            selectedClient.createdAt.toDate
                              ? selectedClient.createdAt.toDate()
                              : selectedClient.createdAt
                          ).toLocaleDateString("fr-FR")}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Liste des dossiers */}
              <div>
                <h4 className="font-semibold text-gray-900 mb-4">
                  Dossiers CE associés ({selectedClient.totalDossiers || 0})
                </h4>

                {selectedClient.dossiers &&
                selectedClient.dossiers.length > 0 ? (
                  <div className="space-y-3">
                    {selectedClient.dossiers.map((dossier, index) => (
                      <div
                        key={dossier.id || index}
                        className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors"
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex-1">
                            <div className="flex items-center gap-3">
                              <h5 className="font-medium text-gray-900">
                                {dossier.orderName || "Dossier sans nom"}
                              </h5>
                              <span
                                className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                  dossier.status === "termine"
                                    ? "bg-green-100 text-green-800"
                                    : dossier.status === "en_cours"
                                    ? "bg-blue-100 text-blue-800"
                                    : "bg-yellow-100 text-yellow-800"
                                }`}
                              >
                                {dossier.status || "En attente"}
                              </span>
                            </div>
                            <div className="mt-1 text-sm text-gray-500">
                              {dossier.createdAt && (
                                <>
                                  Créé le{" "}
                                  {new Date(
                                    dossier.createdAt.toDate
                                      ? dossier.createdAt.toDate()
                                      : dossier.createdAt
                                  ).toLocaleDateString("fr-FR")}{" "}
                                  à{" "}
                                  {new Date(
                                    dossier.createdAt.toDate
                                      ? dossier.createdAt.toDate()
                                      : dossier.createdAt
                                  ).toLocaleTimeString("fr-FR", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </>
                              )}
                            </div>
                            {dossier.revendeur && (
                              <div className="mt-1 text-xs text-gray-400">
                                Revendeur: {dossier.revendeur}
                              </div>
                            )}
                            {dossier.produits &&
                              dossier.produits.length > 0 && (
                                <div className="mt-2">
                                  <span className="text-xs text-gray-500">
                                    Produits:{" "}
                                  </span>
                                  <span className="text-xs text-gray-700">
                                    {dossier.produits
                                      .map((p) => p.name)
                                      .join(", ")}
                                  </span>
                                </div>
                              )}
                          </div>
                          <div className="flex items-center gap-2">
                            {dossier.id && (
                              <button
                                onClick={() =>
                                  navigate(`/fit/orders/${dossier.id}`)
                                }
                                className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                              >
                                Voir dossier
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8 bg-gray-50 rounded-lg">
                    <p className="text-gray-500">
                      Aucun dossier associé à ce client
                    </p>
                    <p className="text-sm text-gray-400 mt-1">
                      Le client est créé mais n'a pas encore de dossiers CE
                      assignés
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="p-6 border-t border-gray-200 bg-gray-50">
              <div className="flex justify-end">
                <button
                  onClick={() => setSelectedClient(null)}
                  className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-medium transition-colors"
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageAccounts;